import type { WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import ServicesContainer from 'connect/core/controls/services'; //web/src/modules/book/controls/pages/controls/category/controls/services';
import type HistoryStore from 'connect/web/src/stores/history-store';
import type SearchStore from 'connect/web/src/stores/search-store';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import type { RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router';
import type { OnlineClinicService } from 'tm3-core/api.dtos';
import styles from './styles';

interface IProps extends WithStyles<typeof styles> {
  historyStore?: HistoryStore;
  searchStore?: SearchStore;
  serviceIds: string;
  title: string;
  description: string;
  footer: string;
}

@withRouter
@inject('historyStore', 'searchStore')
@observer
class ServicesListing extends Component<IProps & RouteComponentProps<any>> {
  @action.bound
  onClick(item: OnlineClinicService) {
    const { historyStore } = this.props;

    historyStore!.push('/book/' + encodeURI(item.urlSlug), true);
  }

  render() {
    const {
      serviceIds = '[]',
      searchStore: { services },
      title,
      description,
      footer,
      classes: { grid }
    } = this.props;

    const ids = JSON.parse(serviceIds) || [];

    const filteredServices = services.filter((x: OnlineClinicService) => ids.includes(x.id));
    return (
      <div className="container" style={{ marginBottom: '10px' }}>
        {title && (
          <Typography color="primary" component="h1">
            {title}
          </Typography>
        )}
        {description && <Typography>{description}</Typography>}
        <ServicesContainer onClick={this.onClick} services={filteredServices} />
        {footer && <Typography>{footer}</Typography>}
      </div>
    );
  }
}

export default withStyles(styles)(ServicesListing);
